import get from 'lodash.get';

import { ResetStateAction } from '../auth/types';
import {
    AppliedFertilizerEntitiesByDateState,
    AppliedFertilizerEntitiesByDateActions
} from './types';
import { APPLIED_FERTILIZER_ENTITIES_BY_DATE_SET } from './constants';
import { RESET_STATE } from '../auth/constants';

const initialState: AppliedFertilizerEntitiesByDateState = {};

export default function (
    state: AppliedFertilizerEntitiesByDateState = initialState,
    action: AppliedFertilizerEntitiesByDateActions | ResetStateAction
): AppliedFertilizerEntitiesByDateState {
    switch (action.type) {
        case APPLIED_FERTILIZER_ENTITIES_BY_DATE_SET:
            return get(action, 'payload', {});
        case RESET_STATE:
            return initialState;
        default:
            return state;
    }
}
